import { Trans } from '@/components'

interface ShowingRangeProps {
  current: number
  size: number
  total: number
}

export function ShowingRange({ current, size, total }: ShowingRangeProps) {
  const from = total === 0 ? 0 : (current - 1) * size + 1
  const to = Math.min(current * size, total)

  return (
    <span className="t-sm text-secondary">
      <Trans ns="modelRoute" i18nKey="showingRange" values={{ from, to, total }}>
        {'Showing {{from}} to {{to}} of {{total}} items'}
      </Trans>
    </span>
  )
}
